const DEFAULT_PRINT_DELAY_MS = 0;

/** Desktop-ish width so mobile browsers don't lay out letter docs at ~390px (squished print). */
const PRINT_VIEWPORT_CONTENT = 'width=1024';

const normalizeFilename = (value) => {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw || raw === '—') return '';
  return raw.replace(/[\\/:*?"<>|]/g, '-');
};

const getViewportMeta = () => document.querySelector('meta[name="viewport"]');

export const printWithFilename = (filename, options = {}) => {
  const { delayMs = DEFAULT_PRINT_DELAY_MS } = options;
  const nextTitle = normalizeFilename(filename);
  const originalTitle = document.title;
  const viewportMeta = getViewportMeta();
  const originalViewport = viewportMeta ? viewportMeta.getAttribute('content') : null;

  const runPrint = () => {
    if (nextTitle) document.title = nextTitle;
    if (viewportMeta) {
      viewportMeta.setAttribute('content', PRINT_VIEWPORT_CONTENT);
    }

    let restored = false;
    const restore = () => {
      if (restored) return;
      restored = true;
      document.title = originalTitle;
      if (viewportMeta && originalViewport != null) {
        viewportMeta.setAttribute('content', originalViewport);
      }
      window.removeEventListener('afterprint', restore);
    };

    window.addEventListener('afterprint', restore);
    // Give the browser a frame to reflow at print viewport width before opening the dialog.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.print();
        setTimeout(restore, 1500);
      });
    });
  };

  if (delayMs > 0) {
    setTimeout(runPrint, delayMs);
    return;
  }
  runPrint();
};
